import { unref as r } from "vue";
import { useTimeout as m } from "./index706.js";
import { buildProps as a } from "./index601.js";
import { isNumber as T } from "./index565.js";
const N = a({
  /**
   * @description delay of appearance, in millisecond, not valid in controlled mode
   */
  showAfter: {
    type: Number,
    default: 0
  },
  /**
   * @description delay of disappear, in millisecond, not valid in controlled mode
   */
  hideAfter: {
    type: Number,
    default: 200
  },
  /**
   * @description disappear automatically, in millisecond, not valid in controlled mode
   */
  autoClose: {
    type: Number,
    default: 0
  }
}), h = ({
  showAfter: i,
  hideAfter: n,
  autoClose: l,
  open: p,
  close: u
}) => {
  const { registerTimeout: s } = m(), {
    registerTimeout: f,
    cancelTimeout: c
  } = m();
  return {
    onOpen: (e, o = r(i)) => {
      s(() => {
        p(e);
        const t = r(l);
        T(t) && t > 0 && f(() => {
          u(e);
        }, t);
      }, o);
    },
    onClose: (e, o = r(n)) => {
      c(), s(() => {
        u(e);
      }, o);
    }
  };
};
export {
  h as useDelayedToggle,
  N as useDelayedToggleProps
};
